import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import Modal from "../../../ui/Modal";

import { useContext } from "../Context";

import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  CancelPopupButton,
  SubmitButton,
} from "../../../../ui/FormElement";

export default function CreateModal({ show, onHide }) {
  const { dispatch, actions, state } = useContext();

  const FormSchema = Yup.object().shape({
    total_employees: Yup.number()
      .required("required")
      .min(1, "Total Employees must be greater than 0"),
  });

  let [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    total_employees: 0,
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.createPolicy(dispatch, state.enterpriseId, values);
  };

  return (
    <>
      <Modal show={show} onHide={onHide} header="Create Policy">
        <BaseForm
          enableReinitialize
          validationSchema={FormSchema}
          initialValues={formData}
          onSubmit={onSubmit}
        >
          <div>
            <TextField
              name="total_employees"
              type="number"
              label={
                <>
                  <span>Total Employees</span>
                  <abbr title="required">*</abbr>
                </>
              }
            />
          </div>
          <div className="mt50 mb30">
            <Row>
              <Col md={6}>
                <CancelPopupButton
                  className="btn btn-primary btn-outline mr5 ml5 width-120"
                  title="Cancel"
                  onClick={() => onHide()}
                />
              </Col>
              <Col md={6} className="text-right">
                <SubmitButton
                  title={`${loader ? "Creating ..." : "Create"}`}
                  className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                    loader ? "not-possible-click" : ""
                  }`}
                />
              </Col>
            </Row>
          </div>
        </BaseForm>
      </Modal>
    </>
  );
}
